import { endings } from "../data/generated";
import type { EndingDefinition, GameState } from "../types";

export function resolveFinalEnding(state: GameState, playerSelectedAnomaly: boolean): EndingDefinition {
  if (state.loopCount >= 8) {
    return endings.find((ending) => ending.id === "archive_deleted") ?? endings[0]!;
  }
  const id = playerSelectedAnomaly ? "shift_complete" : "reemployed";
  return endings.find((ending) => ending.id === id) ?? endings[0]!;
}

export function getEnding(id: string | undefined): EndingDefinition | undefined {
  return endings.find((ending) => ending.id === id);
}
